export const featuresFree = [
  '100 Credits/Day',
  'Daily Targets',
  'Comment Generation',
  'Post Generation',
  'Custom Connection Note',
  'Track Active Day',
  'Active Days Leaderboard',
];

export const featuresPro = [
  'All Free Features',
  '500 Credits/Day',
  'Custom Daily Targets',
  'Priority support',
  'Custom Comment Generation',
  '24/7 Customer Support',
  'Custom integrations',
  'Advanced analytics',
];
